import { nanoIdSchema } from "./shared/id.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/modelExperimentSession.ts
/**
* Mirror of the server's `ModelExperimentSessionStatus` /
* `ModelExperimentChoice` enums (`src/constants/generationTask.ts`).
* Kept inline so the contract package stays free of server-only
* `src/constants/...` imports; canonical definitions stay on the server
* alongside the experiment-session service code.
*/
const ModelExperimentSessionStatus = [
	"pending",
	"selecting",
	"resolved",
	"expired"
];
const ModelExperimentChoice = [
	"picked_left",
	"picked_right",
	"tie",
	"skip"
];
const mediaSchema = z.object({
	mediaId: z.string(),
	mediaUrl: z.string().nullable()
});
const sessionOutputSchema = z.object({
	id: z.string(),
	status: z.enum(ModelExperimentSessionStatus),
	leftMedias: z.array(mediaSchema).nullable(),
	rightMedias: z.array(mediaSchema).nullable(),
	choice: z.enum(ModelExperimentChoice).nullable()
});
const modelExperimentSessionContract = oc.prefix("/task").tag("Model Experiment").router({
	getExpSession: oc.route({
		summary: "Get the A/B model experiment session for a task",
		description: "Returns the experiment session attached to a multi-job root task, with images arranged per the session's display order. Returns 404 when the task has no associated session.",
		method: "GET",
		path: "/{taskId}/model-experiment-session"
	}).input(z.object({ taskId: nanoIdSchema })).output(sessionOutputSchema).errors({
		NOT_FOUND: {
			status: 404,
			message: "Session not found"
		},
		UNAUTHORIZED: {
			status: 401,
			message: "Authentication required"
		}
	}),
	submitPreference: oc.route({
		summary: "Submit the user preference for an A/B experiment session",
		description: "Records the user choice and resolves the session.",
		method: "POST",
		path: "/{taskId}/model-experiment-session/preference"
	}).input(z.object({
		taskId: nanoIdSchema,
		choice: z.enum(ModelExperimentChoice)
	})).output(z.object({ success: z.literal(true) })).errors({
		NOT_FOUND: {
			status: 404,
			message: "Session not found"
		},
		UNAUTHORIZED: {
			status: 401,
			message: "Authentication required"
		},
		CONFLICT: {
			status: 409,
			message: "Session cannot accept a preference (already resolved, expired, or subs not yet ready)"
		}
	})
});
//#endregion
export { modelExperimentSessionContract };
